export default __webpack_public_path__ + "static/media/Navigation.678bcb2e.svg";